<template>
    <div class="terms-wrapper">
        <app-header-mini :img="'/static/img/sitemap/header.jpg'"></app-header-mini>
        <div class="terms-content">
            <h1>Mappa del sito</h1>
            <!-- HOME -->
            <p><router-link class="link-main" to="/">Home</router-link></p>
            <!-- ABOUT US -->
            <p><router-link class="link-main" to="/about-the-company/about-us">Su di noi</router-link></p>
            <p><router-link class="link-sub" to="/about-the-company/about-us">Su di noi</router-link></p>
            <p><router-link class="link-sub" to="/about-the-company/mission-and-values">Mission e valori</router-link></p>
            <p><router-link class="link-sub" to="/about-the-company/key-figures">Dati principali</router-link></p>
            <p><router-link class="link-sub" to="/about-the-company/r-and-d">R&amp;D</router-link></p>
            <p><router-link class="link-sub" to="/about-the-company/rolling-plant">Reparto laminazione</router-link></p>
            <p><router-link class="link-sub" to="/about-the-company/extrusion-plant">Reparto estrusione</router-link></p>
            <p><router-link class="link-sub" to="/about-the-company/timeline">Storia</router-link></p>
            <!-- MARKETS -->
            <p><router-link class="link-main" to="/markets/building-and-architecture">Mercati</router-link></p>
            <p><router-link class="link-sub" to="/markets/building-and-architecture">Edilizia e architettura</router-link></p>
            <p><router-link class="link-sub" to="/markets/automotive">Automotive</router-link></p>
            <p><router-link class="link-sub" to="/markets/transportation">Trasporti</router-link></p>
            <p><router-link class="link-sub" to="/markets/packaging">Packaging</router-link></p>
            <p><router-link class="link-sub" to="/markets/distribution">Distribuzione</router-link></p>
            <!--<p><router-link class="link-sub" to="/markets/packaging">Other industries</router-link></p>
            <!-- PRODUCTS -->
            <p><router-link class="link-main" to="/products">Prodotti</router-link></p>
            <p><router-link class="link-sub" to="/products/rolled-foils/household-foil">Prodotti laminati - Foiled</router-link></p>
            <p><router-link class="link-sub" to="/products/rolled-sheets-and-strips/standard-sheets-and-strips">Prodotti laminati - Lamiere</router-link></p>
            <p><router-link class="link-sub" to="/products/extruded/profiles-for-building-and-architecture">Prodotti estrusi</router-link></p>
            <!-- NEWS -->
            <p><router-link class="link-main" to="/news/1">Notizie</router-link></p>
            <!-- INVESTORS -->
            <p><router-link class="link-main" to="/investors/management">Investitori</router-link></p>
            <p><router-link class="link-sub" to="/investors/management">Dirigenza</router-link></p>
            <p><router-link class="link-sub" to="/investors/financial-statements">Dati finanziari</router-link></p>
            <p><router-link class="link-sub" to="/investors/general-meetings">Assemblea</router-link></p>
            <p><router-link class="link-sub" to="/investors/calendar">Calendario eventi</router-link></p>
            <p><router-link class="link-sub" to="/investors/shares">Azioni</router-link></p>
            <p><router-link class="link-sub" to="/investors/presentations">Presentazioni</router-link></p>
            <!-- SUSTAINABILITY -->
            <p><router-link class="link-main" to="/sustainability/environment">Sostenibilità</router-link></p>
            <p><router-link class="link-sub" to="/sustainability/environment">Ambiente</router-link></p>
            <p><router-link class="link-sub" to="/sustainability/health-and-safety">Salute e sicurezza</router-link></p>
            <p><router-link class="link-sub" to="/sustainability/responsibility">Salute e sicurezza</router-link></p>
            <!-- CONTACTS -->
            <p><router-link class="link-main" to="/contacts/sales-department">Contatti</router-link></p>
            <p><router-link class="link-sub" to="/contacts/sales-department">Dipartamento vendite</router-link></p>
            <p><router-link class="link-sub" to="/contacts/supply-chains">Dipartamento acquisti</router-link></p>
            <p><router-link class="link-sub" to="/contacts/other-contacts">Altri contatti</router-link></p>
            <p><router-link class="link-sub" to="/contacts/locations">Locations</router-link></p>
            <!-- CAREERS -->
            <p><router-link class="link-main" to="/careers/career">Contatti</router-link></p>
            <p><router-link class="link-sub" to="/careers/career">Una Carriera in Alcomet</router-link></p>
            <p><router-link class="link-sub" to="/careers/open-positions">Posizioni disponibili</router-link></p>
            <p><router-link class="link-sub" to="/careers/internships">Tirocini</router-link></p>
            <!-- <p><router-link class="link-sub" to="/careers/application-form">Modulo di domanda</router-link></p> -->
            <!-- TERMS AND CONDITIONS -->
            <p><router-link class="link-main" to="">Terms &amp; conditions</router-link></p>
            <p><router-link class="link-sub" to="/terms-of-use">Terms and conditions of use</router-link></p>
            <p><router-link class="link-sub" to="/disclosure-policy">Politica di comunicazione</router-link></p>
            <p><router-link class="link-sub" to="/personal-data">Dati personali</router-link></p>
            <p><router-link class="link-sub" to="/sitemap">Mappa del sito</router-link></p>
        </div>
    </div>
</template>

<script>
import HeaderMini from "./shared/HeaderMini";
export default {
  components: {
    appHeaderMini: HeaderMini
  }
};
</script>

<style scoped>
.terms-content {
  padding: 0 0 60px;
}
.terms-content > h1 {
  font-size: 34px;
  font-weight: 500;
  margin: 0 auto 25px;
  width: 800px;
}
.terms-content > p {
  font-size: 19px;
  text-align: justify;
  line-height: 32px;
  margin: 5px auto;
  width: 800px;
}
.link-main {
  font-weight: 700;
}
.link-sub {
  font-size: 16px;
  margin-left: 20px;
}
@media screen and (max-width: 1000px) {
  .terms-content > h1 {
    font-size: 20px;
    padding: 0 30px;
    width: 100%;
  }
  .terms-content > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Sitemap.vue